import axios from 'axios';

const upvestStore = {
  state: {
  },
  mutations: {
  },
  actions: {
    async resetPassword(context, userId) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;

      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      return axios.post(`${window.BASE_API.UPVEST_WALLET}admin/user/${userId}/resetPassword`, {}, options)
        .then(response => response.data)
        .catch((error) => {
          Promise.reject(error);
        });
    },
  },
};

export default upvestStore;



// WEBPACK FOOTER //
// ./src/store/upvest/upvestStore.js